import React from 'react';
import { Link } from 'react-router-dom';

import ProfileImage from './ProfileImage';
import { ChevronRightIcon, PhoneIcon } from '../assets/icons';
import { resolveContactImageSrc } from '../utils/image';

import styles from './ContactCard.module.css';

const ContactCard = ({ contact }) => {
  const photoPath = resolveContactImageSrc(contact.photoFile);

  return (
    <Link className={styles.container} to={`/contact/${contact.id}`}>
      <ProfileImage photo={photoPath} disableClick />
      <div className={styles.nameWrapper}>
        <div className={styles.nameText}>{contact.familyHeadName}</div>
        <div className={styles.phoneWrapper}>
          <PhoneIcon className={styles.phoneIcon} />{contact.mobile}
        </div>
      </div>
      <ChevronRightIcon width={20} height={20} />
    </Link>
  );
};

export default ContactCard;
